<template>
  <div class="slider-box" id="certify">
    <!-- 向前滑动 -->
    <div class="swiper-button-prev" slot="button-prev"></div>
    <swiper :options="swiperOption" ref="mySwiper" class="swiper-container">
      <!-- 添加的图片 -->
      <div
        class="swiper-slide"
        v-for="(imgItem, index) in imgUrl"
        :key="index"
      >
        <img :src="imgItem.bg" draggable="false"/>
      </div>
    </swiper>
    <!-- 向后滑动 -->
    <div class="swiper-button-next" slot="button-next"></div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
export default {
  data () {
    return {
      imgUrl: [
        {
          bg: 'https://shs3.b.qianxin.com/qax-cms/0c34c5388c51945baf08fb722066b676.jpg'
        },
        {
          bg: 'https://shs3.b.qianxin.com/qax-cms/e2db8a5f46f8fbe01c4947300dd7f5dd.jpg'
        },
        {
          bg: 'https://shs3.b.qianxin.com/qax-cms/5c037f40f1278a89216c0441f686694e.jpg'
        },
        {
          bg: 'https://shs3.b.qianxin.com/qax-cms/e1fd96de5cdb3e9acab7f76aa49d1c69.jpg'
        },
        {
          bg: 'https://shs3.b.qianxin.com/qax-cms/507a0aeea5e973401ad9714db08ba031.jpg'
        },
        {
          bg: 'https://shs3.b.qianxin.com/qax-cms/deea6135b4781093645e3a3a450d08b1.jpg'
        },
        {
          bg: 'https://shs3.b.qianxin.com/qax-cms/215267d9297aeb1417e120a5377765a2.jpg '
        }
      ],
      swiperOption: {
        watchSlidesProgress: true,
        // 通过宽度自动设定可同时显示的 slides 数量
        slidesPerView: 'auto',
        // 将active slide 设置为居中
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        autoplay: true,
        loopedSlides: 5,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          progress: function (progress) {
            let modify
            let translate
            let scale
            let zIndex
            let slide
            let slideProgress
            for (let i = 0; i < this.slides.length; i++) {
              slide = this.slides.eq(i)
              slideProgress = this.slides[i].progress
              modify = 1
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
              }
              // 控制平移
              translate = slideProgress * modify * 260 + 'px'
              // 控制图片的放大缩小
              scale = 1 - Math.abs(slideProgress) / 5
              // 控制图片优先级，使得 active slide 始终在最上面
              // zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
              slide.transform(
                'translateX(' + translate + ') scale(' + scale + ')'
              )
              slide.css('zIndex', zIndex)
              // 显示所有图片，再设置只显示
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0)
              }
            }
          },
          /**
           * @param {Number} transition - 设定图片滑动过渡的时间
           */
          setTransition: function (transition) {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>

.slider-box {
  width: 100%;
  height: 460px;
  margin: 0 auto;
  position: relative;
}
.swiper-container {
  width: 89%;
  height: 100%;
  display: flex;
  overflow: hidden;
  .swiper-slide-active {
    z-index: 999;
  }
}
.swiper-container .swiper-slide {
  width: 745px !important;
  height: 460px !important;
}
.swiper-slide img {
  display: block;
  width: 745px !important;
  height: 460px !important;
}
.swiper-button-prev {
  color: transparent;
  background: url(../assets/images/btn_swiper_left.png) no-repeat;
}
.swiper-button-next {
  color: transparent;
  background: url(../assets/images/btn_swiper_right.png) no-repeat;
}
</style>
